// WC – In-cart quantity indicator (stable multi-poll version)
// Handles custom .wc-in-cart-count spans AND theme
// .quantity-input-wrapper__cart-count blocks.
// Always uses the latest /cart.js state. No fetch/XHR interception.

document.addEventListener('DOMContentLoaded', function () {
  const indicators = [];

  // 1) Collect custom WC span indicators (if any)
  document.querySelectorAll('.wc-in-cart-count').forEach(function (el) {
    const pid = parseInt(el.getAttribute('data-product-id') || '', 10);
    const vid = parseInt(el.getAttribute('data-variant-id') || '', 10);
    if (!pid && !vid) return;

    indicators.push({
      type: 'wc',
      el,
      productId: pid || null,
      variantId: vid || null
    });
  });

  // 2) Theme built-in "X in cart" blocks (if present)
  document
    .querySelectorAll('.quantity-input-wrapper__cart-count')
    .forEach(function (el) {
      const form = el.closest('form[action*="/cart/add"]');
      if (!form) return;

      const productInput = form.querySelector('input[name="product-id"]');
      const variantInput = form.querySelector('input[name="id"]');

      const pid = productInput
        ? parseInt(productInput.value || '', 10)
        : null;
      const vid = variantInput
        ? parseInt(variantInput.value || '', 10)
        : null;

      if (!pid && !vid) return;

      indicators.push({
        type: 'theme',
        el,
        productId: pid || null,
        variantId: vid || null
      });
    });

  // No indicators on the page → nothing to do
  if (!indicators.length) return;

  // Build totals from /cart.js response
  function buildTotals(cart) {
    const productTotals = {};
    const variantTotals = {};

    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        const qty = item.quantity || 0;

        if (item.product_id != null) {
          productTotals[item.product_id] =
            (productTotals[item.product_id] || 0) + qty;
        }

        if (item.variant_id != null) {
          variantTotals[item.variant_id] =
            (variantTotals[item.variant_id] || 0) + qty;
        }
      });
    }

    return { productTotals, variantTotals };
  }

  // Apply computed totals to all indicator elements
  function applyTotals(cart) {
    const totals = buildTotals(cart);
    const pTotals = totals.productTotals;
    const vTotals = totals.variantTotals;

    indicators.forEach(function (ind) {
      let qty = 0;

      // 1) Prefer variant-level quantity if we have a variant id
      if (ind.variantId && vTotals[ind.variantId]) {
        qty = vTotals[ind.variantId];
      }
      // 2) Fallback: product-level quantity
      else if (ind.productId && pTotals[ind.productId]) {
        qty = pTotals[ind.productId];
      }

      if (ind.type === 'wc') {
        // Our custom WC span → " (X in cart)"
        if (qty > 0) {
          ind.el.textContent = ' (' + qty + ' in cart)';
          ind.el.style.display = '';
        } else {
          ind.el.textContent = '';
          ind.el.style.display = 'none';
        }
      } else if (ind.type === 'theme') {
        // Theme element: update data attribute + inner .item_count
        ind.el.setAttribute('data-cart-item-count', qty);

        const span = ind.el.querySelector('.item_count');

        if (qty > 0) {
          if (span) span.textContent = String(qty);
          ind.el.style.display = '';
        } else {
          if (span) span.textContent = '0';
          // If you want it always visible with "0", comment out the next line.
          ind.el.style.display = 'none';
        }
      }
    });
  }

  // Pull /cart.js and update indicators
  function fetchCartAndUpdate() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        applyTotals(cart);
      })
      .catch(function (err) {
        console.warn('[WC] in-cart indicator /cart.js error', err);
      });
  }

  // Simple helper: schedule one cart sync after a delay
  function scheduleUpdate(delay) {
    const d = typeof delay === 'number' ? delay : 250;
    setTimeout(fetchCartAndUpdate, d);
  }

  // For cart actions that might complete a bit later (AJAX timing),
  // we poll /cart.js a few times so we always catch the final state.
  function scheduleCartActionSync() {
    [150, 600, 1200].forEach(function (ms) {
      scheduleUpdate(ms);
    });
  }

  // 1) Initial sync on page load
  fetchCartAndUpdate();

  // 2) Any /cart/add form submit (Add to Cart)
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (form && form.matches('form[action*="/cart/add"]')) {
        // Let theme AJAX run, then poll cart a few times
        scheduleCartActionSync();
      }
    },
    true
  );

  // 3) Cart UI interactions: drawer, quick-cart, cart page clicks
  document.addEventListener(
    'click',
    function (e) {
      const t = e.target;
      if (!t) return;

      // Add to Cart / quick add buttons
      if (
        t.closest(
          'button[name="add"], .product-form__submit, .quick-add__submit'
        )
      ) {
        scheduleCartActionSync();
      }

      // Any button inside cart UIs (+/–, remove, etc.)
      if (t.closest('.cart-drawer, .quick-cart, .mini-cart, .cart')) {
        scheduleCartActionSync();
      }
    },
    true
  );

  // 4) Quantity input changes in cart UIs
  document.addEventListener(
    'change',
    function (e) {
      const t = e.target;
      if (!t) return;

      if (
        t.closest('.cart-drawer, .quick-cart, .mini-cart, .cart') &&
        (t.matches('input[name*="quantity"]') ||
          t.matches('input[type="number"]'))
      ) {
        scheduleCartActionSync();
      }
    },
    true
  );
});
